// composables/useApiSettings.js
import { useAsyncData } from '#app';
import { useGlobalStore } from '@/stores/global';

// Shares the 'globalSettings' key with layouts/default.vue so Nuxt dedupes
// the request instead of fetching /api/settings twice.
export const useApiSettings = () => {
  const globalStore = useGlobalStore();

  return useAsyncData(
    'globalSettings',
    () => globalStore.fetchData('settings', { retry: 0 }),
    { server: true },
  );
};
